import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Logout = () => {

  const navigate = useNavigate();

  const logoutPageFn = async () => {
    try {
      const res = await axios.get("https://blogappserver-8sw1.onrender.com/logout", {
        withCredentials: true,
      });
      
      if (res.status === 200) {
        // Delete the cookie by setting its expiration date to the past
        document.cookie = "name=jwtoken; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        //user is logout..
        localStorage.clear();
        navigate("/articles");
        // toast("Logout Successful..!!", { type: "success"} )
        window.location.reload(false)
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
        toast("try it again..!!", {type: "error"})
    }
  };

  useEffect(() => {
    logoutPageFn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="err-page">
        <div
          className="err-blog"
          style={{
            backgroundImage: "url(formbg.png)",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            width: "100%",
          }}
        >
          <h1 className="err-header">Thanks For Using it..!!</h1>
          <button
            className="btn btn-sm btn-primary px-5"
            onClick={() => navigate("/articles", { replace: true })}
          >
            Back To Home
          </button>
        </div>
      </div>
    </>
  );
};

export default Logout;
